import { createStyles } from "@mantine/emotion";

export const useStylesCollectionSelect = createStyles((theme) => ({
  collectionSelect: {
    paddingBottom: theme.spacing.collectionSelect.paddingBottom,
    paddingTop: theme.spacing.collectionSelect.paddingTop,
    maxWidth: theme.spacing.collectionSelect.maxWidth,
    marginLeft: "auto",
    marginRight: "auto",
    width: theme.spacing.collectionSelect.width,
  },

  collectionSelectCheckbox: {
    ".mantine-Checkbox-inner": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    ".mantine-Checkbox-input": {
      width: theme.spacing.collectionSelect.checkbox.size,
      height: theme.spacing.collectionSelect.checkbox.size,
    },
    ".mantine-Checkbox-icon": {
      width: theme.spacing.collectionSelect.checkbox.iconWidth,
      left: "0",
      top: "0",
    },
    ".mantine-Checkbox-label": {
      paddingLeft: theme.spacing.collectionSelect.checkbox.labelPadding,
      fontSize: theme.spacing.collectionSelect.checkbox.labelFontSize,
    },
  },

  collectionSelectLabel: {
    fontSize: theme.spacing.collectionSelect.checkbox.labelFontSize,
    color: theme.customColors.black,
  },

  collectionSelectDropdown: {
    width: theme.spacing.collectionSelect.dropdown.width,

    ".mantine-Select-section": {
      "&:before": {
        content: `''`,
        position: "absolute",
        top: "0",
        right: theme.spacing.collectionSelect.dropdown.separatorRight,
        width: "1px",
        height: "100%",
        backgroundColor: theme.customBackgrounds.selectIcon,
        pointerEvents: "none",
      },

      "&:after": {
        content: `''`,
        position: "absolute",
        top: "50%",
        right: theme.spacing.collectionSelect.dropdown.iconRight,
        transform: "translateY(-50%) rotate(0deg)",
        borderLeft: theme.spacing.collectionSelect.dropdown.arrowLeft,
        borderRight: theme.spacing.collectionSelect.dropdown.arrowRight,
        borderTop: theme.spacing.collectionSelect.dropdown.arrowTop,
        transition: "transform 0.3s ease",
        pointerEvents: "none",
      },

      svg: {
        display: "none",
      },
    },

    ".mantine-Select-input": {
      "&:disabled + .mantine-Select-section::after": {
        borderTop: theme.spacing.collectionSelect.dropdown.arrowTopDisabled,
      },
      '&[data-expanded="true"] + .mantine-Select-section::after': {
        transform: "translateY(-50%) rotate(180deg)",
      },
    },
  },

  collectionSelectPlus: {
    width: theme.spacing.collectionSelect.plus.width,
    height: theme.spacing.collectionSelect.plus.height,
    backgroundColor: theme.customBackgrounds.white,
    border: theme.spacing.collectionSelect.plus.border,
    borderRadius: theme.spacing.collectionSelect.plus.borderRadius,
    color: theme.customColors.black,
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: theme.spacing.collectionSelect.plus.fontSize,
    marginLeft: theme.spacing.collectionSelect.plus.marginLeft,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
